import { api } from './api';
import type { Order, OrderFulfillmentStatus, OrderStatus, SellerOrderView } from '@/types/order';

class OrdersService {
  async getMyOrders(): Promise<Order[]> {
    return api.get<Order[]>('/orders');
  }

  async getAdminOrders(): Promise<Order[]> {
    return api.get<Order[]>('/admin/orders');
  }

  async getOrderById(id: string): Promise<Order> {
    return api.get<Order>(`/orders/${id}`);
  }

  async getMySales(): Promise<SellerOrderView[]> {
    return api.get<SellerOrderView[]>('/sellers/me/orders');
  }

  async updateOrderStatus(id: string, status: OrderStatus, comment?: string): Promise<Order> {
    const body: { status: OrderStatus; comment?: string } = { status };
    const c = comment?.trim();
    if (c) body.comment = c;
    return api.patch<Order>(`/orders/${id}/status`, body);
  }

  async updateOrderFulfillment(
    id: string,
    fulfillmentStatus: OrderFulfillmentStatus,
    comment?: string,
  ): Promise<Order> {
    const body: { fulfillmentStatus: OrderFulfillmentStatus; comment?: string } = { fulfillmentStatus };
    const c = comment?.trim();
    if (c) body.comment = c;
    return api.patch<Order>(`/orders/${id}/fulfillment`, body);
  }
}

export const ordersService = new OrdersService();
